// import React, { useState, useEffect } from "react";
// import "./newUser.css";
// import Modal from "@mui/material/Modal";
// import AddModal from "../../components/Modals/AddModal";
// import { ErrorBoundary } from "react-error-boundary";
// import logoBlue from "./logoblue.png";
// import { ArrowBack } from "@material-ui/icons";
// import { useHistory, Link } from "react-router-dom";
// import { createUser } from "../../services/user.services";
// import AnimatedSection from "../../components/AnimationSection/AnimationSection.js";
// import { userList } from "../../pages/userList/UserList.jsx";

// const initialState = {
//   userName: "",
//   email: "",
//   password: "",
//   contactNumber: "",
//   isAdmin: false,
//   deviceTokens:
//     "chJjVsFUR_yF1UDXkREoYF:APA91bFL5EHH0121KJAxT3r8TCBP26m58ctKAoAzQNAMi_IoblChUV0KRRCEHHtY-jDCQ78IC-lpMdJc_iH7DY4jg2DT00sfoQP9aM8MdiUSyRwIImNiCgBuKfVJp_kJynk5cii3D4-n",
// };

// export default function NewUser(props) {
//   const [initialStateForm, setInitialStateForm] = useState(initialState);
//   const [loading, setLoading] = useState(false);
//   const [openAddModal, setOpenAddModal] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");

//   const handleFormChange = (name, value) => {
//     setInitialStateForm((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleCreate = async () => {
//     console.log("called func", initialStateForm);

//     try {
//       setLoading(true);
//       const response = await createUser(
//         initialStateForm,
//         JSON.parse(sessionStorage.getItem("myData"))
//       );
//       console.log("request workingggggg", response.data);
//       setSuccessMessage("User has been created Successfully!"); // Set success message
//       setOpenAddModal(true); // Open the success modal
//       window.location.href = "/userlist";

//       // toggleSuccessModal();
//     } catch (e) {
//       console.error(e);

//       alert(e.response.data.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   let history = useHistory();

//   return (
//     <div className="user">
//       {openAddModal && (
//         <AddModal
//           closeModal={setOpenAddModal}
//           children="User Added Successfully"
//         />
//       )}

//       <div className="newUser">
//         <div className="titleWithBack">
//           <button className="backBtn" onClick={() => history.goBack()}>
//             <ArrowBack className="backBtnIcon" />
//           </button>
//         </div>
//         <img
//           className="newUserLogo"
//           src={logoBlue}
//           alt="logo"
//           width="200px"
//         ></img>
//         <h1 className="newUserTitle">Create User</h1>
//         <form className="newUserForm" id="newUserForm">
//           <div className="newUserItem">
//             <input
//               type="text"
//               placeholder="User Name"
//               value={initialStateForm.userName}
//               onChange={(e) => handleFormChange("userName", e.target.value)}
//             />
//           </div>
//           <div className="newUserItem">
//             <input
//               type="email"
//               placeholder="User Email Address"
//               value={initialStateForm.email}
//               onChange={(e) => handleFormChange("email", e.target.value)}
//             />
//           </div>
//           <div className="newUserItem">
//             <input
//               type="password"
//               placeholder="Password"
//               value={initialStateForm.password}
//               onChange={(e) => handleFormChange("password", e.target.value)}
//             />
//           </div>
//           <div className="newUserItem">
//             <input
//               type="number"
//               placeholder="Contact Number"
//               value={initialStateForm.contactNumber}
//               onChange={(e) =>
//                 handleFormChange("contactNumber", e.target.value)
//               }
//               required
//             />
//           </div>
//           <div className="newUserItemEmpty"></div>

//           <button
//             className="newUserButton"
//             type="button"
//             onClick={() => {
//               handleCreate();
//             }}
//             if
//           >
//             Create
//           </button>
//         </form>

//         <div>{/* <AnimatedSection /> */}</div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import "./newUser.css";
import { useDispatch, useSelector } from "react-redux";
import { createNewUser } from "../../redux/actions/userActions.js";
import { ArrowBack } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import AddModal from "../../components/Modals/AddModal";
import logoBlue from "./logoblue.png";

const initialState = {
  userName: "",
  email: "",
  password: "",
  contactNumber: "",
  isAdmin: false,
  deviceTokens:
    "chJjVsFUR_yF1UDXkREoYF:APA91bFL5EHH0121KJAxT3r8TCBP26m58ctKAoAzQNAMi_IoblChUV0KRRCEHHtY-jDCQ78IC-lpMdJc_iH7DY4jg2DT00sfoQP9aM8MdiUSyRwIImNiCgBuKfVJp_kJynk5cii3D4-n",
};

export default function NewUser() {
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [openAddModal, setOpenAddModal] = useState(false);

  const dispatch = useDispatch();
  const userCreate = useSelector((state) => state.userCreate);
  const { loading, error, success } = userCreate;

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCreate = () => {
    dispatch(createNewUser(initialStateForm));
  };

  useEffect(() => {
    if (success) {
      setOpenAddModal(true);
      setTimeout(() => {
        window.location.href = "/userlist";
      }, 2000);
    }
  }, [success]);

  let history = useHistory();

  return (
    <div className="user">
      {openAddModal && (
        <AddModal
          closeModal={() => setOpenAddModal(false)}
          children="User Added Successfully"
        />
      )}

      <div className="newUser">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
        </div>
        <img
          className="newUserLogo"
          src={logoBlue}
          alt="logo"
          width="200px"
        ></img>
        <h1 className="newUserTitle">Create User</h1>
        <form className="newUserForm" id="newUserForm">
          <div className="newUserItem">
            <input
              type="text"
              placeholder="User Name"
              value={initialStateForm.userName}
              onChange={(e) => handleFormChange("userName", e.target.value)}
            />
          </div>
          <div className="newUserItem">
            <input
              type="email"
              placeholder="User Email Address"
              value={initialStateForm.email}
              onChange={(e) => handleFormChange("email", e.target.value)}
            />
          </div>
          <div className="newUserItem">
            <input
              type="password"
              placeholder="Password"
              value={initialStateForm.password}
              onChange={(e) => handleFormChange("password", e.target.value)}
            />
          </div>
          <div className="newUserItem">
            <input
              type="number"
              placeholder="Contact Number"
              value={initialStateForm.contactNumber}
              onChange={(e) =>
                handleFormChange("contactNumber", e.target.value)
              }
              required
            />
          </div>
          <div className="newUserItemEmpty"></div>

          <button
            className="newUserButton"
            type="button"
            onClick={handleCreate}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </form>

        {error && <div className="errorMessage">{error}</div>}
      </div>
    </div>
  );
}



